var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.09396537,8.84416594 C1.19350789,8.62125842 1.36592584,8.43797001 1.58348001,8.32378876 L11.4859797,3.12655572 C11.8074887,2.95781476 12.1926195,2.95781476 12.5141285,3.12655572 L22.4166282,8.32378876 C22.9519843,8.60476533 23.1558172,9.26204134 22.8719018,9.79185582 C22.7565263,10.007158 22.5713207,10.1777912 22.3460817,10.2763034 L19.0253585,11.7287192 C19.2257015,12.3846849 19.333342,13.0800006 19.333342,13.8 C19.333342,17.7764502 16.0501046,21 12.000026,21 C7.94994736,21 4.66670994,17.7764502 4.66670994,13.8 C4.66670994,13.0800006 4.77435039,12.3846849 4.9746934,11.7287192 L2.83338093,10.7913 L2.83338093,19.4 C2.83338093,19.8970563 2.42297626,20.3 1.91671643,20.3 C1.4104566,20.3 0.999863913,19.8970563 0.999863913,19.4 L1.00010775,9.2934381 C0.998573298,9.14330421 1.02864439,8.99044049 1.09396537,8.84416594 Z M17.3316998,12.4690672 L12.443582,14.6073309 C12.1610761,14.7308897 11.8390321,14.7308897 11.5565262,14.6073309 L6.66835214,12.4690672 C6.55844117,12.8948068 6.50003894,13.3407071 6.50003894,13.8 C6.50003894,16.7823376 8.96246701,19.2 12.000026,19.2 C15.0375849,19.2 17.500013,16.7823376 17.500013,13.8 C17.500013,13.3407071 17.4416108,12.8948068 17.3316998,12.4690672 Z M12.0231914,4.8 L3.75004544,9.33691265 L12.0231914,12.9 L20.2731719,9.3 L12.0231914,4.8 Z",
    id: "wiki-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24/wiki",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "wiki-mask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wiki-path"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "currentcolor",
    xlinkHref: "#wiki-path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#wiki-mask)",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiki);
export default __webpack_public_path__ + "static/media/wiki.c98e95916d8677d87dd610f55ad634e8.svg";
export { ForwardRef as ReactComponent };